module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTING")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('i', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRITUAL")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARFARE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('b', [_vm._v("1   Detecting the Deceiver")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("2 Corinthians 11:1-15")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2   Facing Temptation")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Matthew 4:1-11")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3   The Serpent’s Strategy")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Genesis 3:1-6")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4   The Armor of God")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Ephesians 6:10-20")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5   The War Within")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("James 4:1-10")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6   Defeating the Destroyer")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Mark 5:1-20")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7   Overcoming Our Accuser")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Revelation 12:7-12")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8   Surviving Satan’s Attacks")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("Job 1—2")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9   Standing Firm")]), _c('span', {
    staticClass: "tabulation"
  }, [_vm._v("2 Thessalonians 2:1-17")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leader’s Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Contributor")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 60
// module chunks = 0